export default __webpack_public_path__ + "static/media/dp.287e9e53.jpg";